import Vue from 'vue'

function Impersonate() {
    const self = this
    const STORAGE_KEY = 'impersonate'
    self.state = Vue.observable({
        isActive: false,
    })

    self.login = (originalToken) => {
        window.localStorage.setItem(STORAGE_KEY, originalToken)
        self.state.isActive = true
    }

    self.logout = async () => {
        await Vue.prototype.$user.logout(false)
        window.localStorage.removeItem(STORAGE_KEY)
        self.state.isActive = false
        window.location.href = `${process.env.VUE_APP_ADMIN_PORTAL}logout?impersonate_logout=1`
    }

    self.exit = async () => {
        await Vue.prototype.$user.refreshToken(window.localStorage.getItem(STORAGE_KEY))
        window.localStorage.removeItem(STORAGE_KEY)
        self.state.isActive = false
        window.location.href = `${process.env.VUE_APP_ADMIN_PORTAL}logout?impersonate_exit=1`
    }

    self.state.isActive = !!window.localStorage.getItem(STORAGE_KEY)
}

Vue.use({
    install(Vue) {
        Vue.prototype.$impersonate = new Impersonate()
    },
})
